import React from 'react';
import { Card, CardBody, Col } from 'reactstrap';
import Collapse from '../../../shared/components/Collapse';
import {withTranslation} from "react-i18next";

const FAQ = ({t}) => (
  <Col xs={12} md={12} lg={12}>
    <Card>
      <CardBody>
        <div className="card__title">
          <h5 className="bold-text">{t('wallet.faq.title')}</h5>
          <h5 className="subhead">{t('wallet.faq.subtitle')}</h5>
        </div>
        <Collapse title={t('wallet.faq.is_it_working_now')}>
          <p>{t('wallet.faq.is_it_working_now_body')}</p>
        </Collapse>
        <Collapse title={t('wallet.faq.why_do_i_see_empty_history')}>
          <p>{t('wallet.faq.why_do_i_see_empty_history_body')}</p>
        </Collapse>
        {/* <Collapse title="Other information">
          <p>No comfort do written conduct at prevent manners on. Celebrated contrasted discretion him sympathize
                her collecting occasional. Do answered bachelor occasion in of offended no concerns. Supply worthy
                warmth branch of no ye. Voice tried known to as my to. Though wished merits or be. Alone visit use
                these smart rooms ham. No waiting in on enjoyed placing it inquiry. In no impression assistance
                contrasted. Manners she wishing justice hastily new anxious. At discovery discourse departure objection
                we. Few extensive add delighted tolerably sincerity her. Law ought him least enjoy decay one quick
                court. Expect warmly its tended garden him esteem had remove off. Effects dearest staying now
                sixteen nor improve.
          </p>
        </Collapse>
        <Collapse title="Last group">
          <p>No comfort do written conduct at prevent manners on. Celebrated contrasted discretion him sympathize
                her collecting occasional. Do answered bachelor occasion in of offended no concerns. Supply worthy
                warmth branch of no ye. Voice tried known to as my to. Though wished merits or be. Alone visit use
                these smart rooms ham. No waiting in on enjoyed placing it inquiry. In no impression assistance
                contrasted. Manners she wishing justice hastily new anxious. At discovery discourse departure objection
                we. Few extensive add delighted tolerably sincerity her. Law ought him least enjoy decay one quick
                court. Expect warmly its tended garden him esteem had remove off. Effects dearest staying now
                sixteen nor improve.
          </p>
        </Collapse> */}
      </CardBody>
    </Card>
  </Col>
);


export default withTranslation('dashboard')(FAQ);
